// extracted by mini-css-extract-plugin
module.exports = {"main":"main-module--main--2RKi5","is404":"main-module--is-404--1S2hO"};